"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.same = void 0;

/**
 * Curried funtion that always returns the input given
 *
 * @param {any} source Something, anything
 *
 * @returns {any}
 */
var same = function same(source) {
  return function () {
    return source;
  };
};

exports.same = same;